import { render, staticRenderFns } from "./ComplianceThresholds.vue?vue&type=template&id=5d863358&"
import script from "./ComplianceThresholds.vue?vue&type=script&lang=js&"
export * from "./ComplianceThresholds.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceThresholds.vue?vue&type=style&index=0&id=5d863358&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports